<template>

  <tr
    @click="redirectToJob(job)"
    class="table-tr-pointer">

    <td class="text-truncate">
      <deadline
        :value="job.deadline"
        type="sm">
        </deadline>
    </td>
    <td>
        <div>
          <span
            @click="$event.stopPropagation()">
            <router-link
              style="color: inherit;"
              :to="{path: '/job/' + job._id }">
              {{ job.title }}
              <span class="subtext">#{{ job.code }}</span>
              </router-link>
          </span>

          <span 
            v-if="job.confidential">
            <i class="fas fa-lock" />
            </span>
        </div>

        <div
          class="subtext">
          {{ job.hiring_manager_name }}, {{ $d(new Date(job.date_open)) }}, {{ $tc('n_openings', job.openings, {count: job.openings})  }}
          </div>
        
        <ul
          class="list-tags mt-1"
          v-if="job.tags && job.tags.length">
          <li
            v-for="(tag, index) in job.tags"
            :key="index">
            {{ tag }}
            </li>
        </ul>
    </td>
    <td>
        <div
          v-if="job.company_id">
          {{ job.company_id.name }}
          </div>
        <div
          v-if="job.departament_id"
          class="subtext">
          {{ job.departament_id.name }}
          </div>
    </td>
    <td class="text-truncate">
      <a
        v-if="job.status === 'open' && job.publicate === 'published'"
        @click="$event.stopPropagation()"
        :href="job.career_url"
        target="_blank"
        class="text-success">
        <i class="fas fa-globe-americas" /> Publicada
        </a>
      <div 
        v-if="job.status === 'open' && job.publicate === 'internal'"
        class="text-primary">
        <i class="fas fa-home" /> Interna
        </div>
      <a
        v-if="job.status === 'open' && job.publicate === 'unlisted'"
        @click="$event.stopPropagation()"
        :href="job.career_url"
        target="_blank"
        class="text-warning">
        <i class="fas fa-eye-slash" /> Não listada
        </a>
      <div
        v-if="job.status === 'open' && job.publicate === 'no'"
        class="text-secondary">
        <i class="fas fa-circle-notch"></i> Não publicada
        </div>
      <div
        v-if="job.status === 'archived'"
        class="text-dark">
        <i class="fas fa-circle"></i> {{ $t('Archived') }}
        </div>
    </td>
    <td class="text-truncate">
       <job-list-pipeline
        :pipeline="job.pipeline">
        </job-list-pipeline>

       <span 
        class="badge badge-danger" 
        v-if="job.pipeline.new >= 1">
        {{ job.pipeline.new }} novo(s)
        </span>
    </td>
    <td class="text-truncate">
      <RelatedUser
        :master="job.owner_user_id"
        :users="job.team_users">  
        </RelatedUser>
    </td>

  </tr>

</template>

<script>
import Deadline from '@/components/Parts/Deadline'
import RelatedUser from '@/components/Parts/RelatedUser'
import JobListPipeline from './JobListPipeline'

export default {
  name: 'JobList',
  components: {
    Deadline,
    RelatedUser,
    JobListPipeline
  },
  props: [
    'job'
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    redirectToJob
    */
    redirectToJob (job) {
      this.$router.push({path: '/job/' + job._id})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width : 576px) {
  td {
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/JobList/JobListItem.vue